// extracted by mini-css-extract-plugin
export default {"container":"JobCard_container__ta1Ie","title":"JobCard_title__OHUoN","item-collection":"JobCard_item-collection__o94Uo","label":"JobCard_label__SdcKj"};